// extracted by mini-css-extract-plugin
export default {"contact-data":"ContactData_contact-data__mI+Mw","opacity-up":"ContactData_opacity-up__0PQca","contact-data__socials":"ContactData_contact-data__socials__g0yqb"};